import { Component } from '@angular/core';

import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
    selector: 'page-spinner',
    templateUrl: './page-spinner.component.html',
    styleUrls: ['./page-spinner.component.scss'],
    standalone: false
})
export class PageSpinnerComponent extends SpinnerComponent {

}

